import { render, staticRenderFns } from "./TermReports.vue?vue&type=template&id=371b451b&scoped=true"
import script from "./TermReports.vue?vue&type=script&lang=js"
export * from "./TermReports.vue?vue&type=script&lang=js"
import style0 from "./TermReports.vue?vue&type=style&index=0&id=371b451b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371b451b",
  null
  
)

export default component.exports